import { useSelector } from 'react-redux';

import { selectSelectedCampaign } from '../../redux/selectors';
import { Audience as OutreachAudience } from '../outreach/Audience';
import { PaymentRecoveryAudience } from '../payment-recovery/Audience';

/**
 * Post-creation wrapper: delegates audience by campaign type
 */
export const UnifiedAudience = () => {
  const campaign = useSelector(selectSelectedCampaign);

  if (campaign?.type === 'payment_recovery') {
    return <PaymentRecoveryAudience />;
  }

  return <OutreachAudience />;
};
